import PDFUtils from "./PDFUtils";
import CSVUtils from "./CSVUtils";

export default class ExportData {

  static EXPORT_CONTENT_TYPES = {
    PDF: 'PDF',
    CSV: 'CSV'
  }

  static exportToCsv(data, columns, title) {
    const csv = CSVUtils.convertArrayOfObjectsToCSV({data, columns: columns.filter(x => x.export !== false)});
    if (csv == null) {
      return;
    }
    const fileBlob = new Blob([csv], { type: 'text/csv' })
    const link = document.createElement('a');
    link.setAttribute('href', URL.createObjectURL(fileBlob));
    link.setAttribute('download', 'Relatório de ' + title + '.csv');
    link.click();
  }

  static exportToPDF(data, columns,title) {
    const pdf = PDFUtils.convertArrayOfObjectsToPDF({data, columns: columns.filter(x => x.export !== false), title});
    if (pdf == null) {
      return;
    }
    const dataText = 'data:application/pdf;charset=utf-8,' + pdf;
    const url = encodeURI(dataText);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.click();

  }
}





// WEBPACK FOOTER //
// ./src/utils/ExportData.js